import { cva } from '~/utils/classnames'
import { centsToEurosFormattedPrice } from '~/utils/number'

const priceStyle = cva({
  variants: {
    variant: {
      default: '',
      strikethrough: 'line-through opacity-64',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

interface PriceProps extends Omit<
  React.ComponentPropsWithoutRef<'span'>,
  'prefix'
> {
  variant?: 'default' | 'strikethrough'
  amount: number
  prefix?: React.ReactNode
}

export const Price = ({
  className,
  variant,
  amount,
  prefix,
  ...props
}: PriceProps) => {
  return (
    <span className={priceStyle({ variant, className })} {...props}>
      {prefix}
      {centsToEurosFormattedPrice(amount)}
    </span>
  )
}
